import { quoteCollection } from '../assets/siteData';
import { Section } from '../components/Section';

function formatCategory(category) {
  return category
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function QuotesPage() {
  return (
    <Section
      eyebrow="Quotes"
      title="Minimal, high-contrast thoughts designed for daily brand presence"
      description="Big typography, subtle glow, and futuristic restraint."
    >
      <div className="quotes-grid">
        {quoteCollection.map((quote, index) => (
          <article className="quote-card glass-panel" key={quote.text}>
            <div className="quote-card__meta">
              <span className="quote-card__tag">{formatCategory(quote.category)}</span>
              <span className="quote-card__count">{String(index + 1).padStart(2, '0')}</span>
            </div>
            <blockquote className="quote-card__text">{quote.text}</blockquote>
          </article>
        ))}
      </div>
    </Section>
  );
}
